import React, { FC, useMemo } from "react";
import "./appupdate.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { COUNTRY } from "../../../constants/app";
import { IMAGE_URL_CONFIG } from "../../../constants/url";

const AppUpdate: FC<any> = () => {

    const { countryId, settings } = useSelector((state: RootState) => ({
        countryId: state.applicationReducer.countryId,
        settings: state.applicationReducer.settings
    }))

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const app = useMemo(() => {
        if (countryId === COUNTRY.ANG) {
            return { title: 'Angelika Cinemas' , subtitle: 'Angelika Cinemas', logo:'angelika-logo.svg'}
        } else if (countryId === COUNTRY.STA) {
            return { title: 'State Cinema', subtitle: 'State Cinema' ,logo:'StateLogo.png'}
        } else {
            return { title: 'Reading Cinemas', subtitle: 'Reading Cinemas', logo:'reading_logo_icon.svg' }
        }
    }, [countryId])

    const openLink = () => {
        const userAgent = navigator.userAgent;
        if (/android/i.test(userAgent)) {
            return window.open(settings?.playStoreLink, '_blank');
        } else {
            return window.open(settings?.appleStoreLink, '_blank');
        }
    }

    return isMobile && countryId !== COUNTRY.STA ? <div className="app-update-banner">
        <div className="app-info">
            <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH+app.logo} />
            <div className="app-text">
                <div className="title">{app.title}</div>
                <div className="subtitle">Open in the {app.subtitle} app</div>
            </div>
        </div>
        <button onClick={openLink} className="app-open-btn">OPEN</button>
    </div> : null
};

export default AppUpdate;